import { LineTypeCode } from "@/types";

export default function useGetLineRouteName(
  lineTypeCode?: LineTypeCode,
  routeName?: string,
  lineNum?: string
): string {
  if (!lineNum) {
    return routeName ?? "";
  }

  if (!routeName) {
    return lineNum;
  }

  return lineNum === routeName ? lineNum : `${lineNum}(${routeName})`;
}
